import { render } from "./StarsRomantic.vue?vue&type=template&id=39e66811"
import script from "./StarsRomantic.vue?vue&type=script&lang=js"
export * from "./StarsRomantic.vue?vue&type=script&lang=js"

import "./StarsRomantic.vue?vue&type=style&index=0&id=39e66811&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__